module.exports = __webpack_public_path__ + "static/media/Mitsubachi-3.8331ad89.jpg";